"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M6.128 5.4h11.744c.402 0 .728.326.728.728v11.744a.728.728 0 01-.728.728h-3.368v-5.105h1.722v-.002h.012l.257-1.998h-1.98v-1.272c0-.48.111-.831.622-.937.102-.02.22-.03.357-.03h1.058V7.47a14.622 14.622 0 00-1.536-.077c-1.379 0-2.36.76-2.533 2.17a3.762 3.762 0 00-.028.463v1.47h-1.718v1.998h1.718V18.6H6.128a.728.728 0 01-.728-.728V6.128c0-.402.326-.728.728-.728z" }), "Facebook");
//# sourceMappingURL=Facebook.js.map